import { IApiResponse } from "common//models";
import { API_CONFIG, LOCAL_URL, PRODUCTION, UAT } from "common/config";
import { COMMON_JS } from "common/scripts";

interface IApiReports {
  getDayWiseReport: (args: any) => Promise<IApiResponse>;
  getMonthWiseReport: (args: any) => Promise<IApiResponse>;
  getIndentFlowReport: (args: any) => Promise<IApiResponse>;
  getAlerts: (args: any) => Promise<IApiResponse>;
  getVehicleReport: (args: any) => Promise<IApiResponse>;
  getDriverReport: (args: any) => Promise<IApiResponse>;
  getDocRenewal: (args: any) => Promise<IApiResponse>;
  getTripsRegister: (args: any) => Promise<IApiResponse>;
  getTripStatusRegister: (args: any) => Promise<IApiResponse>;
  getTripLedger: (args: any) => Promise<IApiResponse>;
  getVehicelLedger: (args: any) => Promise<IApiResponse>;
  getDriverLedger: (args: any) => Promise<IApiResponse>;
  getDriverLedgerSummary: (args: any) => Promise<IApiResponse>;
  getBrokerLedger: (args: any) => Promise<IApiResponse>;
  getFuelRegister: (args: any) => Promise<IApiResponse>;
  getExpensesRegister: (args: any) => Promise<IApiResponse>;
  getMileagaeReport: (args: any) => Promise<IApiResponse>;
  getAllLogsRegister: (args: any) => Promise<IApiResponse>;
  getSessionLogsRegister: (args: any) => Promise<IApiResponse>;
  getFlowReport: (args: any) => Promise<IApiResponse>;
  getAlertsReport: (args: any) => Promise<IApiResponse>;
}

const local = PRODUCTION === "false"&& UAT === "false";
export class ApiReports implements IApiReports {
  getDeliveryCommentsReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/MV8RFH57QLEKAOPW";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getOnTimeDeliveries = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/VLWKE0U8RMBYICO1";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getFillRateReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/NK6S5B27903HPZ8D";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getCustomerTripDetails = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/M2B1VFWOR4DQ0839";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getCustomerSupplierBrokerLedger = async (
    args: any
  ): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/7V4H6LC9MPUFYBKD";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTyreEfficiencyReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/RI8AM01E9W3HLPCQ";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getFrequentRepairVehiclesList = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/A5HT39F618VW4KQ7";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getRepairReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/H5AWGIMF4YRLD87P";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTripsOverloadReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/6OIDSQWRKCT1VPZN";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getHighMileageVehicles = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/FRQLD8WT3VZSCM7P";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getAvailableDriversList = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/AQBYRL6SH1K53G0E";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getDayWiseReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = {
        status: 200,
        response: {
          cols: ["Sl No.", "Col 2", "Col 3", "Option"],
          rows: [["1", "Val 2", "Val 3", "1"]],
        },
        error: "",
      };
      // resObj = await COMMON_JS.callApi(
      //   '/re/v1/279W6469O77183US',
      //   API_CONFIG.METHODS.GET,
      //   args,
      // );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getMonthWiseReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/re/v1/279W6469O77183US",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getIndentFlowReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/279W6469O77183IF";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getAlerts = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/re/v1/ZM3H98SOUK7PJT6L",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getVehicleReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/0N6XCQTVZR78J4O5";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getDriverReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/JGCXQUBHDAT9VWOF";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getDocRenewal = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/F1YEC8K2UVQNGPS5";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTripsRegister = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/F9H5ZY8UDEV4K621";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTripStatusRegister = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/RTZOBQ82SYNXAPCI";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTripLedger = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/re/v1/O5GZ46RJ3FHTDPXU",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getVehicelLedger = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/LVMFY3J1OUNARZK7";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getDeliveryEfficiency = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/053VWDMXZUICGFYP";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getDelayedDeliveries = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/JM7APLKEODUWV3TI";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getDwellTimeReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/ADNZFB0GXUQEVMR5";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getDriverLedger = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/245Y1EMIOUFGR6XS";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getDriverLedgerSummary = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/TDL0YP1F5E9VNBGZ";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getBrokerLedger = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/IGU6CLJ539NQAEFT";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getFuelRegister = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/TS1O04QEX6ZLURW3";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getExpensesRegister = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/8C0YU5ZHVDQ4FSGT";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getMileagaeReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/re/v1/MIPA69DCVSWTOGN2",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getAllLogsRegister = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/REXKFJBOHN4VS1C6";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getSessionLogsRegister = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/HGCNRZ0PTQAI4E68";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getFlowReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/re/v1/89LCT7S1BNZ6KHYU",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getAlertsReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/7ZPBAERG3LNSUD6T";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getMileageReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/re/v1/MIPA69DCVSWTOGN2",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getAssetsRegister = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/WEK24SXRZPAM6O5F";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getExpenseAnanlysis = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/C3L7E0OQKBUGN5M4";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getProfitLossAnalysis = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/5JY32VF8CU0HITGQ";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getNonMovementVehicleList = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/ARNJ2BYXLT1ZVH5M";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getLoadingBayReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/FR5BCA41MT2LIVP8";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTurnAroundTime = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/TCVE0M41BOWZHJ5Q";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTransportationCost = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/JNZOV5012IYKHGE4";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getReturnsReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/Q8GR4719NH6WFLD0";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getOdometerMismatch = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/3RI8YG4ZC1V9PK0U";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getIdleRunReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/H5CM9JP7NWKA8L3D";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  getDriverKMDriven = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/FC4APVW756YOKLXH";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getParkingTimeReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/V5H6RGF7US4TCWBX";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getFuelReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/G4O0RQLH69SINPWV";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  getFastagReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/re/v1/2VASYZI8N34C5JD6";
      if (local) {
        apiUrl = LOCAL_URL + ":8005" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
}
